import React from "react";
import { useNavigate } from "react-router";
import POForm from "./POForm";
import { Card, CardContent, Grid } from "@mui/material";

function POFormMobile ({

}) {
    const navigate = useNavigate()
    return (
        <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Card sx={{ maxWidth: 400 }}>
                <CardContent sx={{padding: 0, paddingTop: 2, paddingBottom: 2}}>
                    <POForm loadData={() => {
                        navigate('/po')
                    }}/>
                </CardContent>
            </Card>
        </div>
    )
}

export default POFormMobile